module.exports = __webpack_public_path__ + "static/media/affordable-catering-4.01d2a059.jpg";